import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'icon-button',
  styleUrl: 'icon-button.scss',
})
export class IconButton {
  @Prop() icon: string;
  @Prop() href: string;
  @Prop() alt?: string;

  render() {
    if (this.href) {
      return (
        <a class="ghf-icon-button" href={this.href}>
          <img src={this.icon} alt={this.alt != undefined ? this.alt : ''} />
        </a>
      );
    }
  }
}
